export default {
	// //赠品管理-根据电商单号获取订单信息
	// orderInfo: {
	// 	url: '/ec-pc-api/gift/manage/orderInfo',
	// 	type: 'get'
	// },
	// //赠品管理-新增
	// add: {
	// 	url: '/ec-pc-api/gift/manage/save',
	// 	type: 'post'
	// },
	// //赠品管理-修改
	// update: {
	// 	url: '/ec-pc-api/gift/manage/update',
	// 	type: 'post'
	// },
	// //赠品管理-删除
	// delete: {
	// 	url: '/ec-pc-api/gift/manage/delete',
	// 	type: 'get'
	// },
	// //赠品管理-日志
	// listDialog: {
	// 	url: '/ec-pc-api/gift/manage/list',
	// 	type: 'post'
	// },
	// //赠品管理-分页内容店铺下拉
	// storeList: {
	// 	url: '/ec-pc-api/gift/manage/storeList',
	// 	type: 'get'
	// },
	// //赠品管理-店铺合集下拉
	// allStoreList: {
	// 	url: '/ec-pc-api/gift/manage/allStoreList',
	// 	type: 'get'
	// },
	//赠品登记-线下赠品-编辑
	saveOrUpdateDwon: {
		url: '/ec-pc-api/gift/manage/registerInfo/offline/saveOrUpdate',
		type: 'post'
	},
	//赠品登记-线下赠品-新增
	batchSaveDown: {
		url: '/ec-pc-api/gift/manage/registerInfo/offline/batchSave',
		type: 'post'
	},
	//赠品登记-线上赠品-编辑
	saveOrUpdateUp: {
		url: '/ec-pc-api/gift/manage/registerInfo/online/saveOrUpdate',
		type: 'post'
	},
	//赠品登记-线上赠品-新增
	batchSaveUp: {
		url: '/ec-pc-api/gift/manage/registerInfo/online/batchSave',
		type: 'post'
	},
	//赠品登记-根据电商单号获取订单信息  {fragment: [res.message]}
	orderInfo: {
		url: '/ec-pc-api/gift/manage/registerInfo/orderInfo',
		type: 'get'
	},
	//赠品登记-根据ID删除
	manageDelete: {
		url: '/ec-pc-api/gift/manage/delete',
		type: 'get'
	},
	//赠品登记-地址校验
	checkAddress: {
		url: '/ec-pc-api/gift/manage/check/address/v2',
		type: 'get'
	},
	//赠品审核-线上赠品-编辑
	onlineSaveOrUpdate: {
		url: '/ec-pc-api/gift/manage/audit/online/saveOrUpdate',
		type: 'post'
	},
	//赠品审核-线上赠品-初审
	onlineOne: {
		url: '/ec-pc-api/gift/manage/audit/online',
		type: 'post'
	},
	//赠品审核-线下赠品-编辑
	offlineSaveOrUpdate: {
		url: '/ec-pc-api/gift/manage/audit/offline/saveOrUpdate',
		type: 'post'
	},
	//赠品审核-线下赠品-初审
	offlineOne: {
		url: '/ec-pc-api/gift/manage/audit/offline',
		type: 'post'
	},
	//赠品审核-根据电商单号获取二审关联订单信息
	auditOrderInfo: {
		url: '/ec-pc-api/gift/manage/audit/orderInfo',
		type: 'get'
	},
	//赠品审核-二审
	reviewTwo: {
		url: '/ec-pc-api/gift/manage/audit/review',
		type: 'post'
	},
	//赠品汇总-补录-搜索
	supplementSearch: {
		url: '/ec-pc-api/gift/manage/summary/supplement/search',
		type: 'post'
	},
	//赠品审核-根据电商单号获取二审关联订单信息
	summarySupplement: {
		url: '/ec-pc-api/gift/manage/summary/supplement',
		type: 'post'
	},
	//赠品审核-锁定审核数据(更新为审核中)
	giftManageLock: {
		url: '/ec-pc-api/gift/manage/lock',
		type: 'post'
	},
	//赠品审核-解锁审核数据(更新为未审核)
	giftManageUnLock: {
		url: '/ec-pc-api/gift/manage/unLock',
		type: 'post'
	},
}